<template>
  <header class="topbar">
    <nav class="navbar top-navbar navbar-expand-md navbar-dark">
      <div class="navbar-header">
        <a class="nav-toggler waves-effect waves-light d-block d-md-none" href="javascript:void(0)">
          <i class="ti-menu ti-close"></i>
        </a>
        <router-link class="navbar-brand" to="/dashboard">
          <b class="logo-icon">
            <img src="@/assets/img/logo-icon.png" alt="homepage" class="dark-logo" style="width:40px" />
            <img src="@/assets/img/logo-icon.png" alt="homepage" class="light-logo" style="width:40px" />
          </b>
          <span class="logo-text"><h3 class="mb-0">ControlLabs</h3></span>
        </router-link>
      </div>
      <div class="navbar-collapse collapse" id="navbarSupportedContent">
        <ul class="navbar-nav float-left mr-auto">
          <li class="nav-item d-none d-md-block">
            <a class="nav-link sidebartoggler waves-effect waves-light" href="javascript:void(0)" data-sidebartype="mini-sidebar">
              <i class="sl-icon-menu font-20"></i>
            </a>
          </li>
        </ul>
        <ul class="navbar-nav float-right">
          <li class="nav-item dropdown" :class="{ show: isProfileMenuOpen }">
            <a class="nav-link dropdown-toggle text-muted waves-effect waves-dark pro-pic" href="#" @click.prevent="toggleProfileMenu">
              <img src="@/assets/images/users/1.jpg" alt="user" class="rounded-circle" width="31">
            </a>
            <div class="dropdown-menu dropdown-menu-right user-dd topbar-user-menu" :class="{ show: isProfileMenuOpen }">
              <div class="topbar-user-menu__header">
                <p class="topbar-user-menu__email mb-0">{{ userEmail }}</p>
              </div>
              <div class="topbar-user-menu__body">
                <router-link to="/profile" class="dropdown-item" @click.native="isProfileMenuOpen = false">
                  <i class="ti-user"></i><span>My Profile</span>
                </router-link>
                <a class="dropdown-item" href="#" @click.prevent="handleLogout">
                  <i class="fa fa-power-off"></i><span>Logout</span>
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      isProfileMenuOpen: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    userEmail() {
      return this.user?.email || '-'
    },
  },
  watch: {
    '$route'() {
      this.isProfileMenuOpen = false
    },
  },
  methods: {
    ...mapActions('auth', ['logout']),
    toggleProfileMenu() {
      this.isProfileMenuOpen = !this.isProfileMenuOpen
    },
    async handleLogout() {
      await this.logout()
      this.$toast.success('Logout success')
      this.$router.push('/login')
    },
  },
}
</script>

<style scoped>
.navbar-dark .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.8) !important;
}
</style>
